// @ts-nocheck
import customizeViewSagas from './sagas';
import customizeViewReducer from './reducer';

export const customizeSagas = [customizeViewSagas];
export const customizeReducers = [customizeViewReducer];
